import { passwordStrength } from "@/utils/passwordStrength";

/**
 * Reusable 3-bar password strength meter — uses the same rules as the
 * backend validator. Renders nothing when `value` is empty.
 */
export default function PasswordStrengthMeter({ value, testid = "pwd-strength" }) {
  const s = passwordStrength(value || "");
  if (!value) return null;
  return (
    <div className="space-y-1" data-testid={testid}>
      <div className="flex gap-1 h-1.5">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className={`flex-1 rounded-full transition-colors ${i <= s.level ? s.colorClass : "bg-gray-200"}`}
          />
        ))}
      </div>
      <p className={`text-[11px] ${s.level === 1 ? "text-red-600" : s.level === 2 ? "text-amber-600" : "text-emerald-700"}`}>
        <span className="font-medium">{s.label}</span>
        {s.hint && <span className="text-gray-500"> — {s.hint}</span>}
      </p>
    </div>
  );
}
